import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useState as r, useEffect as i, useRef as e, useCallback as o } from "react";
var _a = function a() {
    return _a = Object.assign || function (t) {
      for (var n, r = 1, i = arguments.length; r < i; r++) for (var e in n = arguments[r]) Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
      return t;
    }, _a.apply(this, arguments);
  },
  l = function () {
    function t() {}
    return t.isString = function (t) {
      return "[object String]" === Object.prototype.toString.call(t);
    }, t.isNumber = function (t) {
      return "[object Number]" === Object.prototype.toString.call(t);
    }, t.getHSL = function (n, r, i) {
      var e = function e(n) {
          return t.isNumber(n) ? n : n.minimum + r * (n.maximum - n.minimum) / i;
        },
        o = e(n.hue),
        a = e(n.saturation),
        l = e(n.level);
      return "hsl(".concat(o, ", ").concat(a, "%, ").concat(l, "%)");
    }, t.getHeight = function (n) {
      return t.isString(n) ? n : "".concat(n, "px");
    }, t;
  }();
!function (t, n) {
  void 0 === n && (n = {});
  var r = n.insertAt;
  if (t && "undefined" != typeof document) {
    var i = document.head || document.getElementsByTagName("head")[0],
      e = document.createElement("style");
    e.type = "text/css", "top" === r && i.firstChild ? i.insertBefore(e, i.firstChild) : i.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
  }
}(":root {\n  --skillBarTextColor: #ffffff;\n  --skillBarBgColor: #eee;\n  --skillBarTitleBgColor: #d35400;\n  --skillBarBg: #e67e22;\n}\n\n.skillbar {\n  position:relative;\n  display:block;\n  margin-bottom:15px;\n  width:100%;\n  background: var(--skillBarBgColor);\n  border-radius: 3px;\n  -moz-border-radius:3px;\n  -webkit-border-radius:3px;\n  -webkit-transition:0.4s linear;\n  -moz-transition:0.4s linear;\n  -ms-transition:0.4s linear;\n  -o-transition:0.4s linear;\n  transition:0.4s linear;\n  -webkit-transition-property:width, background-color;\n  -moz-transition-property:width, background-color;\n  -o-transition-property:width, background-color;\n  transition-property:width, background-color;\n}\n\n.skillbar-title {\n  position:absolute;\n  top:0;\n  left:0;\n  width:110px;\n  font-weight:bold;\n  font-size:13px;\n  color: var(--skillBarTextColor);\n  background: var(--skillBarTitleBgColor);\n  -webkit-border-radius:3px 0 0 4px;\n  -moz-border-radius:3px 0 0 3px;\n  border-radius:3px 0 0 3px;\n  height:inherit;\n}\n\n.skillbar-title span {\n  display:block;\n  background:rgba(0, 0, 0, 0.1);\n  padding:0 20px;\n  height:inherit;\n  line-height:inherit;\n  -webkit-border-top-left-radius:3px;\n  -webkit-border-bottom-left-radius:3px;\n  -moz-border-radius-topleft:3px;\n  -moz-border-radius-bottomleft:3px;\n  border-top-left-radius:3px;\n  border-bottom-left-radius:3px;\n}\n\n.skillbar-bar {\n  height:inherit;\n  position:absolute;\n  left:110px;\n  background: var(--skillBarBg);\n  border-radius: 0 3px 3px 0;\n  -moz-border-radius: 0 3px 3px 0;\n  -webkit-border-radius: 0 3px 3px 0;\n}\n\n.skillbar-percent {\n  position:absolute;\n  right:10px;\n  top:0;\n  font-size:11px;\n  line-height:inherit;\n  color: var(--skillBarTextColor);\n}\n\n.collapsed {\n  width: 0% !important;\n}\n");
var s = function s(_s) {
  var c,
    d = _s.skills,
    u = _s.colors,
    b = _s.barBackground,
    p = void 0 === b ? "transparent" : b,
    h = _s.offset,
    f = void 0 === h ? "25px" : h,
    g = _s.height,
    m = void 0 === g ? 35 : g,
    k = _s.symbol,
    x = void 0 === k ? "%" : k,
    v = _s.animationDuration,
    y = void 0 === v ? 3e3 : v,
    w = _s.animationDelay,
    B = void 0 === w ? 1e3 : w,
    S = _s.animationThreshold,
    C = void 0 === S ? .8 : S,
    T = e(null),
    z = r(!0),
    N = z[0],
    j = z[1],
    H = function () {
      var t = r(!0),
        n = t[0],
        e = t[1];
      return i(function () {
        e(!1);
      }, []), n;
    }();
  c = function (t, n, e) {
    var o = r(null),
      a = o[0],
      l = o[1];
    return i(function () {
      if (!e && t.current && "function" == typeof IntersectionObserver) {
        var r = new IntersectionObserver(function (t) {
          l(t[0]);
        }, n);
        return r.observe(t.current), function () {
          l(null), r.disconnect();
        };
      }
      return function () {};
    }, [t.current, n.threshold, n.root, n.rootMargin]), a;
  }(T, {
    root: null,
    rootMargin: f,
    threshold: C
  }, H), i(function () {
    if (c && c.isIntersecting) {
      var t = setTimeout(function () {
        return j(!1);
      }, B);
      return function () {
        return clearTimeout(t);
      };
    }
  }, [c]);
  var O = o(function (t, n) {
      return t.color && t.color.bar && l.isString(t.color.bar) ? t.color.bar : u && u.bar ? l.isString(u.bar) ? u.bar : l.getHSL(u.bar, n, d.length) : "";
    }, []),
    I = o(function (t, n, r) {
      return t.color && t.color.title && t.color.title[r] && l.isString(t.color.title[r]) ? t.color.title[r] : u && u.title && u.title[r] ? l.isString(u.title[r]) ? u.title[r] : l.getHSL(u.title[r], n, d.length) : "";
    }, []);
  return t("div", _a({
    "data-testid": "skillbar/root",
    ref: T
  }, {
    children: d.map(function (r, i) {
      return n("div", _a({
        className: "skillbar",
        "data-testid": "skillbar/container",
        style: {
          height: "".concat(l.getHeight(m)),
          lineHeight: "".concat(l.getHeight(m)),
          background: p
        }
      }, {
        children: [t("div", _a({
          className: "skillbar-title",
          "data-testid": "skillbar/title",
          style: {
            color: "".concat(I(r, i, "text")),
            background: "".concat(I(r, i, "background"))
          }
        }, {
          children: t("span", {
            children: r.type
          })
        })), t("div", {
          "data-testid": "skillbar/bar",
          className: "skillbar-bar ".concat(N ? "collapsed" : ""),
          style: {
            background: "".concat(O(r, i)),
            width: "calc((100% - 110px) * (".concat(r.level, " * 0.01))"),
            transition: "width ".concat(y, "ms ease-in-out")
          }
        }), n("div", _a({
          className: "skillbar-percent",
          "data-testid": "skillbar/percent"
        }, {
          children: [r.level, x]
        }))]
      }), r.type);
    })
  }));
};
export { s as SkillBar, s as default };